module.exports = __webpack_public_path__ + "img/company-honor.36ec708d.png";